import styled from 'styled-components';

// Shown in standalone tixologist (not embedded in Punchup).
// In Punchup the breadcrumb owns back navigation, so this is hidden.
export const BackButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 8px 0;
	margin-bottom: 8px;
	font-size: 14px;
	display: flex;
	align-items: center;
	gap: 6px;
	color: inherit;

	&:hover {
		opacity: 0.7;
	}
`;
